import HeroImage from '@/assets/images/services_hero.png';
export default function HeroSection() {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={HeroImage}
          alt="Professional Services"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Professional Drafting &<br />Takeoff Services
        </h1>
        <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
          Comprehensive construction documentation and cost estimation solutions for projects of all sizes
        </p>
        <div className="flex flex-wrap gap-4 justify-center items-center">
          <div className="flex items-center gap-2 text-white bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
            <i className="ri-check-line text-2xl"></i>
            <span className="text-base font-medium whitespace-nowrap">15+ Service Types</span>
          </div>
          <div className="flex items-center gap-2 text-white bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
            <i className="ri-time-line text-2xl"></i>
            <span className="text-base font-medium whitespace-nowrap">Fast Turnaround</span>
          </div>
          <div className="flex items-center gap-2 text-white bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
            <i className="ri-shield-check-line text-2xl"></i>
            <span className="text-base font-medium whitespace-nowrap">100% Accuracy</span>
          </div>
        </div>
      </div>
    </section>
  );
}